'use client';

import { Heading, Price } from '@petsmart-ui/sparky';

import { decodeEntityString } from '@libs/algolia';
import type { Product } from '@libs/common-types';

import { PricePolicyDrawer } from '../PricePolicyDrawer';
import { getPriceDisplay } from '../product-details';
import { ResponsivePicture } from '../ResponsivePicture';
import { useMiniPdpDrawer } from './model/use-mini-pdp-drawer';

export function MiniPdpProductInfo({ product }: Readonly<{ product: Product }>) {
    const firstImage = product.media.find(item => item.type === 'image');
    const productName = decodeEntityString(product.name);
    const priceDisplay = getPriceDisplay(product);
    const isDrawerOpen = useMiniPdpDrawer(state => state.isOpen);
    const close = useMiniPdpDrawer(state => state.close);

    return (
        <div className="mini-pdp-drawer__product-info">
            {firstImage && (
                <div className="mini-pdp-drawer__product-image">
                    <ResponsivePicture src={firstImage.url} alt={productName} size={{ width: 80, height: 80 }} />
                </div>
            )}
            <div className="mini-pdp-drawer__product-content">
                <Heading tagName="h3" className="sparky-u-theme-typography-body" data-testid="mini-pdp-product-name">
                    {productName}
                </Heading>
                <div className="mini-pdp-drawer__price">
                    <Price
                        values={priceDisplay.values}
                        variant={priceDisplay.variant}
                        size="xl"
                        className="mini-pdp-drawer__product-price"
                        data-testid="mini-pdp-product-price"
                    />
                    {priceDisplay.variant === 'disabled' && (
                        <PricePolicyDrawer showBackButton forceClosed={!isDrawerOpen} onCloseAll={close} />
                    )}
                </div>
            </div>
        </div>
    );
}
